import React from 'react';
import * as _ from 'lodash';
import {useIntl} from 'react-intl';
import {FileItem} from './FileItem';
import {OrderFileData, useOrderDetailsUIFilesContext} from '../OrderDetailsUIFilesContext';
import Unit from '../../../_common/components/Unit';
import styles from '../styles.module.scss';
import classnames from "classnames";
import themeStyles from "../../../_common/styles/theme.module.scss";
import {useGlobalContext} from "../../../_common/contexts/GlobalContext";

export function FileList() {
  const {formatMessage} = useIntl();
  const {fileList} = useOrderDetailsUIFilesContext();
  const filteredFileList = fileList.filter(Boolean);
  const prefix = 'tab-order-documents-column';
  const {isGlassTheme} = useGlobalContext();

  const [filesInFolders, otherFiles] = _.partition(filteredFileList, file => Boolean(file.folderName));
  const filesByFolders = _.groupBy(filesInFolders, row => row.folderName);
  const filesTotalList = [
    ...Object.entries(filesByFolders),
    ['...', otherFiles]
  ]
    .filter(([/*folderName*/, files]) => files.length > 0) as [string, OrderFileData[]][];

  const renderFileList = (list: [string, OrderFileData[]][]) => {
    return Array.isArray(list) ? list.map(([folderName, files]) => (
      <Unit
        icon={'/media/common/Folder_green.svg'}
        text={folderName} customClassnames={'mb-8'}
      >
        <>
          <div className={classnames(styles.header,
            isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
            isGlassTheme ? themeStyles.primaryBackground : themeStyles.usualBackground
          )}>
            <div className={styles.headerCell}/>
            <div className={styles.headerCell}>
              {formatMessage({id: `${prefix}-uploadDate`, defaultMessage: 'Upload date'})}
            </div>
            <div className={styles.headerCell}>
              {formatMessage({id: `${prefix}-uploadedByUser`, defaultMessage: 'User'})}
            </div>
            <div className={styles.headerCell}>
              {formatMessage({id: `${prefix}-fileName`, defaultMessage: 'Name'})}
            </div>
            <div className={styles.headerCell}>
              {formatMessage({id: `${prefix}-fileType`, defaultMessage: 'Type'})}
            </div>
            <div className={styles.headerCell}>
              {formatMessage({id: `${prefix}-docType`, defaultMessage: 'Document type'})}
            </div>
            <div className={styles.headerCell}/>
          </div>
          <div className={styles.list}>
            {files.map(file => <FileItem {...file}/>)}
          </div>
        </>
      </Unit>
    )) : null;
  };

  return <>{renderFileList(filesTotalList)}</>;
}